<template>
  <div id="app">
    <el-container>
      <el-header>
        <jp-navigation />
      </el-header>
      <el-main>
        <transition>
          <router-view/>
        </transition>
      </el-main>
      <el-footer>
        <jp-footer />
      </el-footer>
    </el-container>
    <div class="flex-top" @click="scrollToTop" v-show="showTop"><i class="el-icon-top"></i></div>
  </div>
</template>

<script>
import _ from 'lodash';
import jpNavigation from '@/components/navigation';
import jpFooter from '@/components/footer';

export default {
  name: 'App',
  components: {
    jpNavigation,
    jpFooter
  },
  data() {
    return {
      showTop: false,
      target: null,
      top: 0
    };
  },
  watch: {
    '$i18n.locale'() {
      if (this.$i18n.locale === 'jp') {
        // document.getElementById('app').style.fontFamily = 'MyYuGothicM,YuGothic';
      }
    }
  },
  mounted() {
    // document.getElementsByClassName('el-main')[0].style.height = window.innerHeight - 160 + 'px';
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: _.debounce(function() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showTop = scrollTop > 300;
    }, 300),
    scrollToTop() {
      // 直接到顶
      // document.getElementById("app").scrollIntoView()
      // 部分浏览器可以动画
      // window.scrollTo({
      //   top:0,
      //   behavior:'smooth'
      // })

      let distance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; 
      //获得当前高度
      let step = distance/50; 
      //每步的距离
      this.jump(step ,distance)
    },
    jump(step, distance) {
      if(distance > 0){
        distance -= step;
        window.scrollTo(0,distance);
        setTimeout(() => {
          this.jump(step, distance)
        },10)
      }
    }
  }
}
</script>

<style>
#app {
  font-family:"Microsoft YaHei",微软雅黑,"Microsoft JhengHei",华文细黑,STHeiti,MingLiu;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue